import { SelectedFilters } from '@/components/FilterData/types';
import { api } from '@/services/api';
import { UUID } from '@/api/generatedApi';
import {
  normalizeSelectedFilters,
  normalizeSearchQuery,
  normalizePage,
  normalizePerPage,
} from '@/components/Search/utils';

export const CROSS_TENANT_ASSETS_PART_SEARCH_QUERY_KEY = 'crossTenant.assetsPartSearch';

export const queryKey = ({
  assetId,
  assetTenantId,
  searchTenantId,
  searchQuery,
  selectedFilters,
  minThreshold,
  page,
  perPage,
}: {
  assetId: UUID;
  assetTenantId: UUID;
  searchTenantId: UUID;
  searchQuery?: string;
  selectedFilters?: SelectedFilters;
  minThreshold: number;
  page?: string | number;
  perPage?: string | number;
}) => [
  CROSS_TENANT_ASSETS_PART_SEARCH_QUERY_KEY,
  {
    assetId,
    assetTenantId,
    searchTenantId,
    searchQuery: normalizeSearchQuery(searchQuery),
    selectedFilters: normalizeSelectedFilters(selectedFilters),
    minThreshold,
    page: normalizePage(page),
    perPage: normalizePerPage(perPage),
  },
];

export const queryFunction =
  ({
    assetId,
    assetTenantId,
    searchTenantId,
    searchQuery,
    selectedFilters,
    minThreshold,
    page,
    perPage,
  }: {
    assetId: UUID;
    assetTenantId: UUID;
    searchTenantId: UUID;
    searchQuery?: string;
    selectedFilters?: SelectedFilters;
    minThreshold: number;
    page?: string | number;
    perPage?: string | number;
  }) =>
  () =>
    api.crossTenant.crossTenantPartSearch({
      assetId,
      assetTenantId,
      searchTenantId,
      searchQuery: normalizeSearchQuery(searchQuery),
      filters: normalizeSelectedFilters(selectedFilters),
      minThreshold,
      page: normalizePage(page),
      perPage: normalizePerPage(perPage),
    });
